<template>  
<div> <!-- root element start -->
    <div  class="row" v-if="dataComp == 0">
      <div class="col-12 mt-4">
        <scaling-squares-spinner :animation-duration="2000" :size="65" color="#0E1698" style="margin:auto"/>
      </div>
    </div>
    <div v-if="dataComp == 1" class="row">
      <div class="col-12">
        <div class="card border-0">
          <div class="card-header bg-transparent border-0 pb-0 d-flex justify-content-between align-items-center">
            <span class="h5">Contacts</span>
            <a href="#" @click="addContact"><small class="">Add a Contact</small></a>
          </div>

          <div class="card-body"  style="max-height:350px; overflow:auto">

              <div v-for="(item,index) in data" class="row mb-2">
                <div class="col-12">
                  <span class="font-weight-bold">{{item.f_name}} {{item.l_name}}</span>
                </div>
                <div class="col-12">
                  <span class="">{{item.pri_email}}</span>
                </div>
                <div v-if="item.pri_phone != null" class="col-12">
                  <span class="">{{item.pri_phone}}</span>
                </div>
                <div class="col-12">
                  <hr>
                </div>
              </div>

          </div>
        </div>
      </div>
    </div>


</div> <!-- root element end -->
</template>


<script>
import { ScalingSquaresSpinner } from 'epic-spinners'
import {store} from '../../stores/org-main-store.js'


// import catMain from '../InstComponents/CategoryComponents/category-main.vue'


export default {
  store,
  data: function () {
    return { 



    }
  },
  computed: {
    data () { return this.$store.state.orgContacts },
    dataComp () { return this.$store.state.orgContactsComp },
  },
  watch: {
    
  },
  mounted() {
    
  },
  methods: {
    changeRightView(name, prop1, prop2) { this.$store.dispatch("getRightView", { name: name, prop1: prop1, prop2: prop2 }); },

    addContact(){
      var _this = this;
      _this.$emit('onSecComplete', ['launchAddContact', 2])

    }
  },    
  components:{
    ScalingSquaresSpinner
  },
  filters: {

  }
}
</script>
